module.exports = __webpack_public_path__ + "img/pr-3.8d441144.png";